import { render, staticRenderFns } from "./ShoppingDetail.vue?vue&type=template&id=1edb112b&scoped=true"
import script from "./ShoppingDetail.vue?vue&type=script&lang=js"
export * from "./ShoppingDetail.vue?vue&type=script&lang=js"
import style0 from "./ShoppingDetail.vue?vue&type=style&index=0&id=1edb112b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edb112b",
  null
  
)

export default component.exports